import { HttpEvent, HttpEventType, HttpProgressEvent, HttpResponse } from '@angular/common/http';
import { Observable, filter, map, tap } from 'rxjs';

export const isHttpResponse = <T>(event: HttpEvent<T>): event is HttpResponse<T> => event.type === HttpEventType.Response;

export const isHttpProgressEvent = (event: HttpEvent<unknown>): event is HttpProgressEvent =>
  event.type === HttpEventType.DownloadProgress || event.type === HttpEventType.UploadProgress;

/**
 * calculates the progress
 *
 * @param event the progress event
 * @param maxPercent max cap for result
 * @returns -1 when unable to calculate progress, otherwise completion percentage
 */
export const calculatePercentage = (event: HttpProgressEvent, maxPercent?: number): number => {
  if (!event.total) {
    return -1;
  }
  let percent = (100 * event.loaded) / event.total;
  if (maxPercent && percent > maxPercent) {
    percent = maxPercent;
  }
  return Math.round(percent);
};

export const watchProgressEmitBody =
  <T>(progressCallback: (progress: number) => void, maxPercent?: number) =>
  (source: Observable<HttpEvent<T>>) =>
    source.pipe(
      tap((event) => {
        if (isHttpProgressEvent(event)) {
          progressCallback(calculatePercentage(event, maxPercent));
        }
      }),
      filter(isHttpResponse),
      map((response) => response.body)
    );
